import React from 'react'
import MultipleFS from '../../../componentes/MultipleFS'
import InventarioTools from '../Componentes/editarInventario'
import PositiveNumInput from '../../../componentes/PositiveNumInput/PositiveNumInput'
import Single from '../../../componentes/Single'
import { getCompanyCollection } from '../../../firebase'

class Aplicar extends React.Component {
    constructor(props) {
        super(props)
        this.extraoptions = [
            { key: "1", text: "Biologicos", value: "Biologicos" },
            { key: "2", text: "Desecho", value: "Desecho" }
        ]
        this.state = {
            aplicacion: {
                producto: '',
                zonas: [],
                cantidad: 0,
                unidades: '',
            },
            ubicacion: this.props.almacen,
            message: '',
            enInventario: 0,
            buttonDisabled: true,
        }
    }
    componentDidUpdate(prevProps, prevState){
        if (prevProps.almacen !== this.props.almacen ||
            prevState.aplicacion.producto !== this.state.aplicacion.producto) {
            this.setState({ ubicacion: this.props.almacen }, ()=>{
                this.revisarInventario()
            })
        }
        if(this.state.aplicacion.producto && 
            this.state.aplicacion.zonas && 
            this.state.aplicacion.cantidad && 
            this.state.buttonDisabled &&
            this.state.ubicacion)
        {
            this.setState({
                buttonDisabled: false,
            })
        }
        console.log(this.state.aplicacion)
    }
    handleChange = (e, { name, value }) => {
        const aplicacion = { ...this.state.aplicacion }
        if (name === 'producto') {
            aplicacion[name] = value
        } else if (name==='cantidad'){
            if(value>this.state.enInventario || value<0)
            return null
        } else if (name==='zonas'){
            aplicacion.zonas = value
        }
        this.setState({ aplicacion: aplicacion })
    }
    revisarInventario = async () => {
        console.log(this.state.ubicacion)
        const aplicacion = { ...this.state.aplicacion }
        const inventory = await getCompanyCollection('Inventario')
        const producto = (await inventory
        .where('nombre', '==', aplicacion.producto)
        .where('ubicacion', '==', this.state.ubicacion)
        .get()).docs[0]
        if(producto){
            aplicacion.unidades = producto.data().unidades
        }
        const enInventario=producto? producto.data().enInventario : 0
        this.setState({
            aplicacion: aplicacion,
            enInventario: enInventario,
        })
    }
    handleSubmit = () => {
        InventarioTools.restar(
            this.state.ubicacion,
            this.state.aplicacion.producto, 
            this.state.aplicacion.zonas, 
            this.state.aplicacion.cantidad
        )
        this.setState({
            aplicacion: {
                producto: '',
                zonas: [],
                cantidad: 0,
                unidades: '',
            },
        })
        this.props.onSave()
    }
    render() {
        return (
            <section>
                    <Single search
                        placeholder='Producto' 
                        tabla='Productos' 
                        columna='nombre' 
                        onChange={this.handleChange} 
                        name='producto' 
                        value={this.state.aplicacion.producto} 
                    />
                    <MultipleFS search 
                        extraoptions={this.extraoptions}
                        placeholder='Zonas' 
                        tabla='Zonas' 
                        columna='sector' 
                        onChange={this.handleChange} 
                        name='zonas' 
                        value={this.state.aplicacion.zonas} 
                    />
                    <PositiveNumInput 
                        type='number' 
                        className="inputInt"
                        onChange={this.handleChange} 
                        value={this.state.aplicacion.cantidad} 
                        name='cantidad' 
                    />
                    <button disabled={this.state.buttonDisabled} onClick={this.handleSubmit}>Aplicar</button>
                <p>En inventario: {`${this.state.enInventario} ${this.state.aplicacion.unidades}`}</p>
                <p>{this.state.message}</p>
            </section>
        )
    }
}

export default Aplicar
